export const NO_MORE_PAGES_TO_READ = -1;
export const DEFAULT_INBOX_PAGE_SIZE = 15;
